import { FormattedMessage } from 'react-intl'

export const PaginationCaption = ({ firstItemIndex, lastItemIndex, totalItems }: TSFixMe): TSFixMe => {
  return (
    <FormattedMessage
      id="pagination.caption"
      defaultMessage="{firstItemIndex} - {lastItemIndex} of {totalItems}"
      values={{
        firstItemIndex,
        lastItemIndex,
        totalItems
      }}
    />
  )
}
